import { useState } from "react";
import { Nav } from "react-bootstrap";
import MedicalTab from "./medicalTab";
import ReligiousTab from "./religiousTab";

export default function ReligiousOrMedicalTab() {
    const [activeTab, setActiveTab] = useState('religious');

    return (
        <>
            <Nav variant="tabs" className='religious-medical-tab' activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
		<Nav.Item>
                    <Nav.Link eventKey="religious">Religious Exemption</Nav.Link>
                </Nav.Item>                
		<Nav.Item>
                    <Nav.Link eventKey="medical">Medical Exemption</Nav.Link>
                </Nav.Item>
            </Nav>

            {activeTab === 'religious' ? (<ReligiousTab />) : (<MedicalTab />)}
        </>
    );
}
